/**
 * ConditionalWrapper component wraps its children with any given component
 * if the condition is true, otherwise it renders the children directly.
 * By default, it will use a div as the wrapper component.
 *
 * // Usage example:
 * <ConditionalWrapper condition={true} className="grid">
 *   <p>Leesa</p>
 * </ConditionalWrapper>
 * // This will render: <div className="grid"><p>Leesa</p></div>
 */
const ConditionalWrapper = ({
  condition,
  className,
  component: Component = 'div',
  children
}) =>
  condition ? (
    <Component className={className}>{children}</Component>
  ) : (
    <>{children}</>
  );

export default ConditionalWrapper;
